'use strict';

var React = require('react');

/* Actions */
var TranslationEditorActions = require('actions/translation-editor');

/* Stores */
var ModuleInspectorStore = require('stores/module-inspector');

/* Components */
var Button = require('components/ui/button');

var TypeTranslationCollection = React.createClass({
  displayName: 'TypeTranslationCollection',

  render: function render() {
    var component = this;
    var props = this.props;

    var valueTranslation = ModuleInspectorStore.translate(props.groupName + '_' + props.name);

    return React.createElement(Button, { disabled: props.disabled, value: valueTranslation, onClick: component._onPerformAction });
  },

  _onPerformAction: function _onPerformAction() {
    var props = this.props;
    var baseTranslationKey = props.groupName + '_' + props.name;

    TranslationEditorActions.openEditor(props.name, baseTranslationKey, props.values, props.value, this._onTranslationSaved);
  },

  _onTranslationSaved: function _onTranslationSaved(value) {
    var props = this.props;

    if (props.onChange) {
      props.onChange(props.value, value);
    }
  }
});

module.exports = TypeTranslationCollection;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module/inspector/type/translation-collection.js
 **/